/**
 * PayerFocusPanel — what an institutional payer needs to ACTION today.
 *
 * Two blocks surfaced by /api/dashboard/focus (role=payer):
 *   • vbc_status         — VBC score + status ("Below/On/Exceeding target")
 *   • readmission_watch  — 30-day readmission % + live watch cohort size
 *
 * Both drive the primary_action (Review cohort | Export report), which the
 * FocusHero renders as the top-of-shell CTA button.
 */
import React from 'react';
import { FocusCard, FocusHero } from './FocusCard';

export function PayerFocusPanel({ focus }) {
  const blocks = focus?.blocks || [];
  const byKey = Object.fromEntries(blocks.map((b) => [b.key, b]));

  return (
    <div className="space-y-6" data-testid="payer-focus-panel">
      <FocusHero
        title="Where your network stands today."
        subtitle="VBC score and the 30-day readmission watch first — everything else lives in the full dashboard below."
        primaryAction={focus?.primary_action}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FocusCard
          block={byKey.vbc_status}
          testIdPrefix="payer-focus"
          emptyHint="No VBC signal yet — data lands after the first 30-day windows close."
        />
        <FocusCard
          block={byKey.readmission_watch}
          testIdPrefix="payer-focus"
          emptyHint="No members in the 30-day watch window."
        />
      </div>
    </div>
  );
}
